module.exports = __webpack_public_path__ + "img/image_online06@2x.00da7ffc.png";